/*
 * Product page redesign — the comparison tables keep their kit names and
 * prices in view while you scroll down the rows. Used by the kit table on the
 * page (pdp-kits) and the compare view in the bundle drawer (pdp-hero), so it
 * guards against running twice.
 *
 * Both tables scroll sideways inside their own box, and that box stops
 * position: sticky working on the table's own cells. So each table carries a
 * one-row copy of its names and prices (.pdp-stickyhead) laid over it, which
 * sticks instead. This script:
 *
 *   - gives the copy's columns the table's widths;
 *   - keeps the copy level with the table as it scrolls sideways;
 *   - shows the copy once the table's own head has gone under the bars above.
 *
 * The copy is hidden from assistive tech and ignores the pointer, so a swipe
 * on it scrolls the table underneath.
 */
(function () {
  if (window.pdpStickyHeadLoaded) return;
  window.pdpStickyHeadLoaded = true;

  // The box the page scrolls in: the drawer's body, or the window.
  function scrollParentOf(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var oy = getComputedStyle(p).overflowY;
      if (oy === 'auto' || oy === 'scroll') return p;
    }
    return window;
  }

  function init(wrap) {
    if (wrap.pdpStickyHead) return;
    var head = wrap.querySelector('[data-pdp-stickyhead]');
    var scroller = wrap.querySelector('[data-pdp-stickyhead-scroll]');
    var table = scroller && scroller.querySelector('table');
    if (!head || !table || !table.tHead) return;
    wrap.pdpStickyHead = true;

    var bar = head.querySelector('.pdp-stickyhead__bar');
    var pane = head.querySelector('.pdp-stickyhead__scroll');
    var copy = pane.querySelector('table');
    var thead = table.tHead;
    // The row with the names: the last one in the head (a group row may sit above it).
    var source = thead.rows[thead.rows.length - 1];

    function measure() {
      var width = table.getBoundingClientRect().width;
      var cells = source.cells;
      var copyCells = copy.rows[0] ? copy.rows[0].cells : [];
      if (!width || cells.length !== copyCells.length) return;
      copy.style.width = width + 'px';
      for (var i = 0; i < cells.length; i++) {
        copyCells[i].style.width = cells[i].getBoundingClientRect().width + 'px';
      }

      // The old prices show beside the prices only if every one of them fits,
      // so a column never has one when its neighbour doesn't. One that didn't
      // fit has wrapped a whole line down; on the same line it only sits a
      // pixel or two lower, being smaller type on the same baseline.
      head.classList.remove('is-tight');
      var tight = false;
      copy.querySelectorAll('.pdp-stickyhead__price').forEach(function (line) {
        var price = line.firstElementChild;
        var was = line.querySelector('s');
        if (was && was.offsetTop > price.offsetTop + price.offsetHeight / 2) tight = true;
      });
      head.classList.toggle('is-tight', tight);
    }

    function syncX() {
      pane.scrollLeft = scroller.scrollLeft;
      head.classList.toggle('is-more', scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 2);
    }

    // On once the bottom of the table's head has passed the copy's top. At
    // rest the copy sits at the top of the table, so the two only cross once
    // the copy has stuck under the bars.
    var frame = 0;
    function update() {
      frame = 0;
      var shown = table.getClientRects().length > 0;
      var on = shown && thead.getBoundingClientRect().bottom <= bar.getBoundingClientRect().top + 0.5;
      head.classList.toggle('is-on', on);
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function refresh() {
      measure();
      syncX();
      update();
    }

    scroller.addEventListener('scroll', syncX, { passive: true });
    scrollParentOf(wrap).addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', refresh);
    // The box lists opening, the drawer showing this view.
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(table);
    // The web font changes how wide the prices are.
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(refresh);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refresh);
    }
    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-pdp-stickyhead-wrap]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-run when the section is re-rendered.
  document.addEventListener('shopify:section:load', boot);
})();
